import { v4 as uuidv4 } from 'uuid';
/**
 * ユニークIDを生成するユーティリティ関数
 * BE側でplaywrightを実行しているため、generateUuidは使用せずuuidモジュールを使用している
 */
export const generateUuid = () => {
  return uuidv4();
};
